import { render, staticRenderFns } from "./TraderInfoKanri.vue?vue&type=template&id=6b7d4d0b&"
import script from "./TraderInfoKanri.vue?vue&type=script&lang=ts&"
export * from "./TraderInfoKanri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports